import { IUser, ICompany, IProvince } from "common/types";
import { MsApp } from "msd/dist/ms-header";
import { VhMenu } from "msd/dist/vh-sider";
import { VhButtonPermission } from "msd/dist/vh-button/VhButton";

/**
 * 应用类型
 *
 * @export
 * @interface App
 */
export interface App {
  /**
   * 应用id
   */
  ID: string;
  /**
   * 应用名称
   */
  appName: string;
  /**
   * 应用code
   */
  appCode: string;
  /**
   * 应用组id
   */
  appGroupID: number;
  /**
   * 安装模式
   * 1#默认安装，2#手动安装（审核），3#手动安装（无需审核）
   */
  setupMode: string;
  /**
   * 星级
   */
  stars: number;
  /**
   * 付费模式
   * 1#免费，2#付费
   */
  payMode: number;
  /**
   * 应用访问地址
   */
  appURL: string;
  /**
   * 应用字体名称
   */
  appFontName: string;
  /**
   * 应用字体颜色
   */
  appFontColor: string;
  /**
   * 事件通知地址
   */
  notifyURL: string;
  /**
   * 是否有应用配置
   * 1#是，0#否
   */
  appConfigFlag: number;
  /**
   * 应用配置地址
   */
  appConfigURL: string;
  /**
   * 是否有权限配置:
   * 1#是，0#否
   */
  permissionConfigFlag: number;
  /**
   * 权限配置地址
   */
  permissionConfigURL: string;
  /**
   * 显示方式：
   * 1#内嵌、2#外联
   */
  displayMode: number;
  /**
   * 是否有工作台:
   * 1#是，0#否
   */
  workbenchFlag: number;
  /**
   * 应用代号
   */
  appAlias: string;
  /**
   * 开发者
   */
  developer: string;
  /**
   * 产品线
   */
  productLine: string;
}

export interface Menu {
  /**
   * id
   */
  id: string;
  /**
   * 分组名称
   */
  groupName: string;
  /**
   * 分组图标
   */
  groupIconName: string;
  /**
   * 功能名称
   */
  functionName: string;
  /**
   * 功能编码
   */
  functionCode: string;
  /**
   * 功能图标
   */
  iconName: string;
  /**
   * 访问地址
   */
  visitURL: string;
}

/**
 * action类型枚举
 *
 * @export
 * @enum {number}
 */
export enum AuthorizationActionTypes {
  // 获取用户信息
  FETCH_USER_INFO = "@@authorization/FETCH_USER_INFO",
  FETCH_USER_INFO_SUCCESS = "@@authorization/FETCH_USER_INFO_SUCCESS",
  FETCH_USER_INFO_ERROR = "@@authorization/FETCH_USER_INFO_ERROR",

  // 获取用户权限
  FETCH_USER_PERMISSION = "@@authorization/FETCH_USER_PERMISSION",
  FETCH_USER_PERMISSION_SUCCESS = "@@authorization/FETCH_USER_PERMISSION_SUCCESS",
  FETCH_USER_PERMISSION_ERROR = "@@authorization/FETCH_USER_PERMISSION_ERROR",

  // 获取应用列表
  FETCH_APP_LIST = "@@authorization/FETCH_APP_LIST",
  FETCH_APP_LIST_SUCCESS = "@@authorization/FETCH_APP_LIST_SUCCESS",
  FETCH_APP_LIST_ERROR = "@@authorization/FETCH_APP_LIST_ERROR",

  // 获取用户配置应用列表（个人设置，公司设置等权限）
  FETCH_CONFIG_APP_LIST = "@@authorization/FETCH_CONFIG_APP_LIST",
  FETCH_CONFIG_APP_LIST_SUCCESS = "@@authorization/FETCH_CONFIG_APP_LIST_SUCCESS",
  FETCH_CONFIG_APP_LIST_ERROR = "@@authorization/FETCH_CONFIG_APP_LIST_ERROR",

  // 保存常用应用列表
  FETCH_APP_SAVE = "@@authorization/FETCH_APP_SAVE",
  FETCH_APP_SAVE_SUCCESS = "@@authorization/FETCH_APP_SAVE_SUCCESS",
  FETCH_APP_SAVE_ERROR = "@@authorization/FETCH_APP_SAVE_ERROR",

  // 获取菜单列表
  FETCH_MENU_LIST = "@@authorization/FETCH_MENU_LIST",
  FETCH_MENU_LIST_SUCCESS = "@@authorization/FETCH_MENU_LIST_SUCCESS",
  FETCH_MENU_LIST_ERROR = "@@authorization/FETCH_MENU_LIST_ERROR",

  // 获取公共字典
  FETCH_COMMON_MAP = "@@authorization/FETCH_COMMON_MAP",
  FETCH_COMMON_MAP_SUCCESS = "@@authorization/FETCH_COMMON_MAP_SUCCESS",
  FETCH_COMMON_MAP_ERROR = "@@authorization/FETCH_COMMON_MAP_ERROR",

  // 获取登出
  FETCH_LOGOUT = "@@authorization/FETCH_LOGOUT",
  FETCH_LOGOUT_SUCCESS = "@@authorization/FETCH_LOGOUT_SUCCESS",
  FETCH_LOGOUT_ERROR = "@@authorization/FETCH_LOGOUT_ERROR",

  // 获取省市信息
  FETCH_PROVINCE_LIST = "@@authorization/FETCH_PROVINCE_LIST",
  FETCH_PROVINCE_LIST_SUCCESS = "@@authorization/FETCH_PROVINCE_LIST_SUCCESS",
  FETCH_PROVINCE_LIST_ERROR = "@@authorization/FETCH_PROVINCE_LIST_ERROR",

  FETCH_GET_PROJECT_SETTING = "@@authorization/FETCH_GET_PROJECT_SETTING",
  FETCH_GET_PROJECT_SETTING_SUCCESS = "@@authorization/FETCH_GET_PROJECT_SETTING_SUCCESS",
  FETCH_GET_PROJECT_SETTING_ERROR = "@@authorization/FETCH_GET_PROJECT_SETTING_ERROR",
}

/**
 * Authorization state
 *
 * @export
 * @interface AuthorizationState
 */
export interface AuthorizationState {
  readonly userInfo: IUser;
  readonly companyInfo: ICompany;
  readonly appList: MsApp[];
  readonly configAppList: MsApp[];
  readonly permissionList: VhButtonPermission[];
  readonly appInfo: MsApp;
  readonly menuList: VhMenu[];
  readonly commonMap: any;
  readonly provinceList: IProvince[];
  readonly errors?: string;
  readonly loading: boolean;
  readonly projectSetting: any;
}
